import axios from 'axios';

export const state = {
  directSignings: [],
  loading: false,
};

export const mutations = {
  setDirectSignings(context, directSignings) {
    context.directSignings = directSignings;
    context.loading = false;
  },

  setLoading(context, value) {
    context.loading = value;
  },
};

export const actions = {
  async getDirectSignings({ commit, rootState }, query) {
    try {
      const { jwtToken } = rootState.userStore.user.signInUserSession.idToken;
      const options = {
        headers: {
          Authorization: jwtToken,
        },
      };
      commit('setLoading', true);
      const directSignings = await axios.get(`${window.BASE_API.INVESTMENT_REPORTING_ENGINE}/documents/admin/list/direct-signing?${query}`, options)
        .then(response => response);

      commit('setDirectSignings', directSignings.data);
      commit('setLoading', false);
    } catch (err) {
      commit('setLoading', false);
    }
  },
};

const directSigningsStore = {
  state,
  mutations,
  actions,
};

export default directSigningsStore;



// WEBPACK FOOTER //
// ./src/store/ire/directSigningsStore.js